// PromoBanner.js
import React, { useState } from "react";
import PromotionalModal from "./PromotionalModal";
import promoBanner from "../assets/images/Banners/1080x1080/promo.webp"; // Adjust the path as necessary

const PromoBanner = ({ banner }) => {
  const [showModal, setShowModal] = useState(true);
//console.log(banners, "banners in promo banner");
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      {showModal && (
        <PromotionalModal onClose={handleClose}>
          <a
            href={banner.url}
            style={{ display: "block", width: "100%", height: "100%" }}
          >
            <img
              src={banner.src}
              alt={banner.alt} 
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </a>
        </PromotionalModal>
      )}
    </>
  );
};

export default PromoBanner;
